var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewClienteVenta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1464;}.cls-2{fill:#b06328;}.cls-3{fill:#b0c4d8;}.cls-4{fill:#99b4cd;}.cls-5{fill:#c4d7e5;}.cls-6{fill:#70b7e5;}.cls-7{fill:#92c5eb;}.cls-8{fill:#4c9cd6;}.cls-9{fill:#b0c9db;}.cls-10{fill:#e2e7f0;}.cls-11{fill:#a35425;}.cls-12{fill:#c97629;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3005-07-2019") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 35,
    height: 35,
    rx: 3.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.5,28.75h0a1.77,1.77,0,0,1-1.75,1.75h0a1.82,1.82,0,0,1-1.3-.55l-5.6-6.1a.48.48,0,0,1,0-.7l1.3-1.3a.48.48,0,0,1,.7,0L30,27.5A1.7,1.7,0,0,1,30.5,28.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.05,
    y: 20.7,
    width: 1.4,
    height: 2.1,
    transform: "translate(-9.01 21.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.25,22.25l.25.25L23,22l-1.5-1.5-1,1,.75.75h0A.67.67,0,0,1,22.25,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16,8.5A7.5,7.5,0,1,0,23.5,16,7.49,7.49,0,0,0,16,8.5ZM16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 16,
    cy: 16,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.05,16.7a4.24,4.24,0,0,1,3.65-3.65h.05a.74.74,0,0,0,.1-1.45,5,5,0,0,0-1.5,0A4.45,4.45,0,0,0,11.6,15.3a3.76,3.76,0,0,0,.05,1.5.73.73,0,0,0,1.45-.1C13.05,16.75,13.05,16.7,13.05,16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M10.5,16.5a6,6,0,0,1,6-6,6.26,6.26,0,0,1,4,1.5A5.93,5.93,0,0,0,16,10a6,6,0,0,0-6,6,6.11,6.11,0,0,0,2,4.5A6.26,6.26,0,0,1,10.5,16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16,23.5h0A7.49,7.49,0,0,0,23.5,16h0a.5.5,0,0,0-.5.5,6.8,6.8,0,0,1-2,4.4A7,7,0,0,1,16.5,23,.5.5,0,0,0,16,23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M16,8.5h0A7.49,7.49,0,0,0,8.5,16h0a.5.5,0,0,0,.5-.5,6.77,6.77,0,0,1,1.85-4.25A7.34,7.34,0,0,1,15.5,9,.5.5,0,0,0,16,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.9,27.45l-.3-.25a1.75,1.75,0,0,1,.4,1.1h0a.72.72,0,0,1-1.25.45L23.5,23.5a.72.72,0,0,0-1.05,0L22,24l5.45,5.85a2,2,0,0,0,1.1.6,1.75,1.75,0,0,0,1.95-1.95A1.56,1.56,0,0,0,29.9,27.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M24.75,24a.3.3,0,0,1-.2-.05L23.3,22.7a.25.25,0,0,1,.35-.35L24.9,23.6a.24.24,0,0,1,0,.35C24.9,24,24.8,24,24.75,24Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewClienteVenta);
export default __webpack_public_path__ + "static/media/view-cliente-venta.cc8a08ad24b269050ef22567715afd36.svg";
export { ForwardRef as ReactComponent };